import { IDeviceInfo } from '../interfaces';

export const DEVICES_CONSTANT: IDeviceInfo[] = [
  {
    meterType: 'lightning',
    conflictedDevices: ['v1'], // Devices that can not run with this device together in the same session
    platforms: ['iOS'],
    meterTag: 'Duo',
    connectorString: 'Lightning port',
    image: 'duo',
    isNew: false,
    phone: 'iPhone Lightning',
    eventSource: 'app.duo',
    category: 'meter',
  },
  {
    meterType: 'usb',
    platforms: ['Android'],
    meterTag: 'Duo C',
    connectorString: 'USB-C port',
    image: 'duo-c',
    isNew: true,
    phone: 'USB-C, Android Only',
    eventSource: 'app.duo-c',
    category: 'meter',
  },
  {
    meterType: 'v1',
    platforms: ['iOS', 'Android'],
    conflictedDevices: ['lightning'], // Devices that can not run with this device together in the same session
    meterTag: 'Nano',
    connectorString: 'headphone jack',
    image: 'nano',
    isNew: false,
    phone: 'Android Headphone Jack',
    eventSource: 'app.nano',
    category: 'meter',
  },
  {
    meterType: 'bleScale',
    platforms: ['iOS', 'Android'],
    conflictedDevices: [], // Devices that can not run with this device together in the same session
    meterTag: 'Wifi Scale',
    connectorString: 'Bluetooth',
    // TODO change to asset image
    image: 'nano',
    isNew: true,
    phone: 'Android Headphone Jack',
    eventSource: 'app.bleScale',
    category: 'scale',
  },
];

export default DEVICES_CONSTANT;
